import {
  useCentraClient,
  useSelection,
  useSelectionKey,
} from "@frend-digital/centra/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCurrency = () =>
  useSelection({
    select: (data) => data.selection?.currency,
  });

export const usePricelist = () => {
  return useSelection({
    select: (data) => data.location?.pricelist,
  });
};

export const useLocation = () => {
  return useSelection({
    select: (data) => data.location,
  });
};
export const useCountries = () => {
  return useSelection({
    select: (data) => data.countries,
  });
};

export const useSetLocation = () => {
  const queryClient = useQueryClient();
  const client = useCentraClient();
  const selectionKey = useSelectionKey();
  return useMutation({
    mutationFn: async (location: { country: string }) => {
      // Your mutation logic here
      const { data, error } = await client.PUT("/countries/{country}", {
        params: {
          path: {
            country: location.country,
          },
        },
      });

      if (error) {
        throw error;
      }

      return data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(selectionKey, () => data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: selectionKey,
      });
      queryClient.invalidateQueries({
        queryKey: ["selection"],
      });
    },
  });
};
